import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const WordContainer = styled.div<{
  width: string;
  align: any;
}>`
  width: ${(props) => props.width};
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.align || "center"};

  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;

export const Word = styled.div<{ fontSize?: number }>`
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : "16px")};
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
